// The donor's shared text truncation (`timmy/src/utils/common.ts:9-19`).
//
// **A character count, not CSS.** `text-overflow: ellipsis` cuts where the box
// runs out; this cuts at a fixed number of characters and appends a literal
// `...`, so the same string is cut at the same place however wide the column is
// — and the cut text is really absent from the DOM rather than merely clipped.
// The two look alike and are not: the donor's callers pair this with a tooltip
// carrying the untruncated value, which only makes sense because the visible
// text is genuinely short.
//
// Ported as a shared helper rather than inlined because the donor's is shared,
// and because the length is the caller's decision rather than this function's.
// The donor's is a default (`maxLength = 50`) that its two list call sites take
// by omitting the argument (`item-card.tsx:107`, `item-data-row.tsx:100`) and
// the add-variant screen overrides; this port makes every caller pass one, so
// `item-heading.tsx` spells out the 50 and `add-variant-preview-card.tsx` its
// own 25 and 80.

/** `text`, or its first `maxLength` characters with `...` after them. */
export function truncateText(text: string, maxLength: number): string {
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
}
